<section class="social-media mb-3">
  <div class="row m-0 header justify-content-center">
    <h1 class="title">Redes Sociales</h1>
  </div>
  <div class="row m-0 mt-3 mt-md-5">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center">
      <h2>¡Síguenos en nuestras redes sociales para mantenerte actualizado!</h2>

      <!-- iFrames Widgets starts -->
      <div class="row mb-5">
        <div class="col-12 col-md-4 my-3 my-md-0 text-center">
          <img
            src="assets/img/redes-sociales-01.svg"
            alt="Logo Facebook"
            height="60"
          />
          <h2>Colegio de Arquitectos</h2>
          <div
            class="fb-page"
            data-href="https://www.facebook.com/Colegiodearquitectostabasquenos/"
            data-tabs="timeline"
            data-width=""
            data-height=""
            data-small-header="true"
            data-adapt-container-width="true"
            data-hide-cover="true"
            data-show-facepile="true"
          >
            <blockquote
              cite="https://www.facebook.com/Colegiodearquitectostabasquenos/"
              class="fb-xfbml-parse-ignore"
            >
              <a
                href="https://www.facebook.com/Colegiodearquitectostabasquenos/"
                >Colegio de Arquitectos Tabasqueños A.C.</a
              >
            </blockquote>
          </div>
        </div>
        <!---
        <div class="col-12 col-md-4 my-3 my-md-0 text-center">
          <h2>Jóvenes Arquitectos de Tabasco</h2>
          <div
            class="fb-page"
            data-href="https://www.facebook.com/J&#xf3;venes-Arquitectos-de-Tabasco-1189684937828398/"
            data-tabs="timeline"
            data-width=""
            data-height=""
            data-small-header="true"
            data-adapt-container-width="true"
            data-hide-cover="true"
            data-show-facepile="true"
          >
            <blockquote
              cite="https://www.facebook.com/J&#xf3;venes-Arquitectos-de-Tabasco-1189684937828398/"
              class="fb-xfbml-parse-ignore"
            >
              <a
                href="https://www.facebook.com/J&#xf3;venes-Arquitectos-de-Tabasco-1189684937828398/"
                >Jóvenes Arquitectos de Tabasco</a
              >
            </blockquote>
          </div>
        </div>
        --->
        <div class="col-12 col-md-4 my-3 my-md-0 text-center">
          <img
            src="assets/img/redes-sociales-02.svg"
            alt="Logo Twitter"
            height="60"
          />
          <h2>Arquitectos Tabasqueños</h2>
          <div class="tw-page">
            <a
              class="twitter-timeline"
              data-width="340"
              data-height="515"
              href="https://twitter.com/ArquitectosTab?ref_src=twsrc%5Etfw"
              >Tweets by ArquitectosTab</a
            >
          </div>
        </div>

        <div class="col-12 col-md-4 my-3 my-md-0 text-center">
          <img
            src="assets/img/redes-sociales-03.svg"
            alt="Logo Instagram"
            height="60"
          />
          <h2>Arquitectos Tabasqueños</h2>
          <div class="instagram-widget">
            <a
              href="https://www.instagram.com/colegio_arquis_tabasco/"
              target="blank"
            >
              <img
                src="assets/img/Instagram Widget.jpg"
                alt="Intagram de Arquitectos Tabasqueños"
              />
            </a>
          </div>
        </div>
      </div>
      <!-- iFrames Widgets ends -->
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
